import React, { Suspense } from 'react';
import { connect } from 'react-redux';

import BlockSkeleton from '#app/components/common/BlockSkeleton';
import TaskForm from '#app/components/relations/Tasks/form/TaskForm';
import {
  setTaskForm,
  setTaskModalVisible,
  setTaskType,
} from '#app/store/actions/task';

import { AuthLayout, Header, Phone } from './LazyLoadedPages';


interface CabinetLayoutStateProps {
  modalVisible?: boolean;
  taskForm?: any;
  taskType?: any;
  auth?: any;
}

interface CabinetLayoutDispatchProps {
  setTaskModalVisible: (visible: boolean) => void;
  setTaskType: (type: any) => void;
  setTaskForm: (form: any) => void;
}

type CabinetLayoutProps = CabinetLayoutStateProps & CabinetLayoutDispatchProps;

const EMPTY_TASK_FORM: Record<string, unknown> = {};

const CabinetLayout: React.FC<CabinetLayoutProps> = ({
  modalVisible,
  setTaskModalVisible,
  taskForm,
  taskType,
  setTaskType,
  setTaskForm,
  auth,
}) => (
  <Suspense fallback={<BlockSkeleton lines={4} />}>
    <Header />
    <AuthLayout />
    <Phone />
    <TaskForm
      setModalVisible={setTaskModalVisible}
      modalVisible={!!modalVisible}
      form={taskForm ?? EMPTY_TASK_FORM}
      taskType={taskType ?? { id: 'event', title: 'Событие' }}
      setTaskType={setTaskType}
      setForm={setTaskForm}
      callback={() => {}}
      auth={auth}
    />
  </Suspense>
);

const enhance = connect(
  (state: {
    task: { modalVisible?: boolean; form?: any; type?: any };
    auth: any;
  }) => ({
    modalVisible: state.task.modalVisible,
    taskForm: state.task.form,
    taskType: state.task.type,
    auth: state.auth,
  }),
  { setTaskModalVisible, setTaskForm, setTaskType }
);

export default enhance(CabinetLayout);
